import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss'
})
export class TabComponent {
  @Input() tabTitle!: string;
  @Input() active = false;
  @Input() borderless: boolean = false;

  @Input() showEditButton: boolean = false;
  @Input() showAddButton: boolean = false;
  @Input() showSaveButton: boolean = false;
  @Output() editButtonClicked = new EventEmitter<boolean>();
  @Output() addButtonClicked = new EventEmitter<boolean>();
  @Output() saveButtonClicked = new EventEmitter<boolean>();
  @Output() deleteButtonClicked = new EventEmitter<boolean>();
}
